import { useCallback, useEffect, useState } from 'react';
import { EntityListResp } from '@/types/home';
import { getEntityList } from '@/services/home';

export const useEntityList = () => {
  const [entityLoading, setEntityLoading] = useState<boolean>(true);
  const [entityList, setEntityList] = useState<EntityListResp[]>([]);

  const fetchData = useCallback(async () => {
    try {
      setEntityLoading(true);
      const { code, result } = await getEntityList();

      if (code === 0 && result) {
        setEntityList(result);
      } else {
        setEntityList([]);
      }
      setEntityLoading(false);
    } catch {
      setEntityLoading(false);
      setEntityList([]);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return {
    entityLoading,
    entityList,
  };
};
